module.exports = __webpack_public_path__ + "static/media/maria_corina_barbaros.591f12f1.png";